import { WLClient } from '../../config';

// TODO: analyze code for other client-specific features and move them here
export type ClientSpecificFeatures =
  | 'authSmsCheckboxRequired'
  | 'hasMarketingPage'
  | 'calculatorUseZipDepartureSearch'
  | 'calculatorUseZipDestinationSearch'
  | 'calculatorSkipCapitalPrefillUnloggedUser'
  | 'showTaxesOnSummaryDomestic'
  | 'useGstHstInsteadOfTaxes'
  | 'mainPageSubtitleEasyParcelShipping'
  | 'mainPageCountriesListDeliveryTo'
  | 'mainPage214Countries'
  | 'zipMinLengthSixChars'
  | 'hideMobilAppInfo'
  | 'aboutUsLinkRequired'
  | 'becomeAgentRequired'
  | 'trustPilotWidgetRequired'
  | 'privacyOptLinkRequired'
  | 'otherProductsRequired'
  | 'showAgentSenderTip'
  | 'recipientPhoneNumberBlocked'
  | 'prohibitedItemsDetailsLinkRequired'
  | 'optionalEmailDomesticeReceiverAllowed';

export type ClientSpecificFeaturesStyling =
  'welcomeScreenSecondaryCancelButton';

export const ClientConfig: Record<
  ClientSpecificFeatures | ClientSpecificFeaturesStyling,
  Partial<Record<WLClient, string[]>>
> = {
  // NOTE: empty countries array means that feature is applied to ALL countries
  calculatorUseZipDepartureSearch: { polonez: [], meest: ['CA'] },
  calculatorUseZipDestinationSearch: { polonez: [] },
  calculatorSkipCapitalPrefillUnloggedUser: { meest: [], polonez: [] },
  authSmsCheckboxRequired: {},
  hasMarketingPage: { meest: [] },
  welcomeScreenSecondaryCancelButton: { polonez: [] },
  showTaxesOnSummaryDomestic: { meest: ['CA'] },
  useGstHstInsteadOfTaxes: { meest: ['CA'] },
  mainPageSubtitleEasyParcelShipping: { meest: ['CA'] },
  mainPage214Countries: { meest: ['CA'] },
  mainPageCountriesListDeliveryTo: { meest: ['CA'] },
  hideMobilAppInfo: { meest: ['CA'] },
  zipMinLengthSixChars: { meest: ['CA'] },
  becomeAgentRequired: { meest: [] },
  aboutUsLinkRequired: { meest: [] },
  trustPilotWidgetRequired: {},
  privacyOptLinkRequired: { polonez: ['US'] },
  otherProductsRequired: { meest: [] },
  showAgentSenderTip: { meest: ['US'] },
  recipientPhoneNumberBlocked: { polonez: ['PL'] },
  prohibitedItemsDetailsLinkRequired: { polonez: [] },
  optionalEmailDomesticeReceiverAllowed: { meest: ['US', 'CA'] },
};
